import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetCampaignSupporterDataRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetCampaignSupporterDataResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setCampaignSupporterData = (request: SetCampaignSupporterDataRequest, options?: CashRequestOptions) =>
  post<SetCampaignSupporterDataRequest, SetCampaignSupporterDataResponse>(
    '/2.0/cash/set-campaign-supporter-data',
    request,
    { ...options, rejectOnError: true }
  )
